import React, { useContext, useEffect, useState } from 'react'
import SearchContext from '../context/SearchContext'

const Paging = () => {
	const { handlePageChange, hitsPerPage, carsInStock, params } = useContext(SearchContext);

	const [numberOfPages, setNumberOfPages] = useState(0)
	const [currentPage, setCurrentPage] = useState( parseInt(params.get('page') || 1))


	useEffect(() => {
		setNumberOfPages(Math.ceil(carsInStock / hitsPerPage))
		setCurrentPage( parseInt(params.get('page') || 1) )
	}, [carsInStock, numberOfPages, hitsPerPage, params])

	return (
		<>
			<div className='container p-b-2'>
				<ul className='paging'>
					{numberOfPages > 1 &&
						Array.from({ length: numberOfPages }, (_, i) => i + 1).map((p) => {
							return (
								<li key={p}>
									<a href={'#page-' + p}
										onClick={(e) => {
											e.preventDefault();
											handlePageChange(p)
										}}
										className={p === currentPage ? 'current' : ''}
									>
										{p}
									</a>
								</li>
							)
						})}
				</ul>
			</div>
		</>
	)
}

export default Paging
